module.exports = __webpack_public_path__ + "img/沙洲坝中华苏维埃共和国中央执行委员会旧址.df3af378.png";